module.exports = __webpack_public_path__ + "static/fonts/fzss-big.c0f071d.ttf";